export default __webpack_public_path__ + "static/media/2354.a28b4fdf.png";